<template>
<v-dialog v-model="show_contest_dialog" max-width="800" persistent>
  <v-card>
    <v-card-title class="secondary">
      <h5 class="white--text text--darken-3">New Contest</h5>
      <v-spacer></v-spacer>
      <v-btn dark icon @click="videoTutorial">
        <v-icon>fa-question</v-icon>
      </v-btn>
      <v-btn icon dark @click="show_contest_dialog=false">
        <v-icon>fa-times</v-icon>
      </v-btn>
    </v-card-title>
    <div>
      <v-stepper v-model="step">
        <v-stepper-header class="">
          <v-stepper-step :complete="stepComplete(1)" step="1">Details</v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step :complete="stepComplete(2)" step="2">Images</v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step step="3" :complete="stepComplete(3)">Contact</v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1" class="pa-0">
            <v-card flat>
              <v-container fluid style="max-height:75vh;overflow-y:auto">
                <v-form ref="contest-form" lazy-validation>
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-text-field clearable v-model="contest.talk_about" outlined hide-details label="Talk About"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field clearable v-model="contest.brand_name" outlined hide-details label="Brand"></v-text-field>
                    </v-col>

                    <v-col cols="12">
                      <v-text-field clearable v-model="contest.prize" outlined hide-details label="Prize To Winner" append-icon="fa-gift"></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-textarea clearable v-model="contest.notes" hide-details :rows="3" label="Challenge" outlined></v-textarea>
                    </v-col>
                  </v-row>
                </v-form>
              </v-container>

              <v-card-actions class="grey lighten-3">
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="goNext" :disabled="!stepComplete(1)">
                  Continue
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-stepper-content>

          <v-stepper-content step="2" class="pa-0">
            <v-card flat>
              <v-container fluid style="max-height:75vh;overflow-y:auto">
                <v-row justify="space-around">
                  <v-col cols="12" class="text-center" v-if="$store.state.app.display ==='xs' || $store.state.app.display ==='sm'">
                    <h4 class="grey--text">Add Images</h4>
                  </v-col>
                  <v-col cols="4" class="text-center">
                    <image-picker title="Logo" :size="150" v-model="contest.brand_logo"></image-picker>
                  </v-col>
                  <v-col cols="4" class="text-center">
                    <image-picker title="Prize" :tile="true" :size="150" v-model="contest.prize_image"></image-picker>
                  </v-col>
                </v-row>
              </v-container>

              <v-card-actions class="grey lighten-3">
                <v-btn text @click="step=1">Back</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="step = 3" :disabled="!stepComplete(2)">
                  Continue
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-stepper-content>

          <v-stepper-content step="3" class="pa-0">
            <v-card flat>
              <v-container fluid style="max-height:75vh;overflow-y:auto">

                <v-form ref="contact-form" lazy-validation>
                  <v-row justify="center" class="pb-4">
                    <v-col cols="12" md="6" class="py-0">
                      <v-text-field outlined v-model="contact_info.name" :rules="[rules.required,rules.fullName]" clearable label="Name"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6" class="py-0">
                      <v-text-field outlined v-model="contact_info.phone" type="tel" v-mask="'+1 (###) ###-####'" clearable label="Phone Number"></v-text-field>
                    </v-col>
                    <v-col cols="12" class="py-0">
                      <v-text-field outlined v-model="contact_info.email" :rules="[rules.required,rules.email]" clearable label="Email address"></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="12" class="text-center">
                      <span class="caption">By clicking submit you agree to our <a href="/business-terms" target="_blank">Terms of Use</a>, <a href="/privacy" target="_blank">Privacy Statement</a>, and that you are over 18.</span>
                    </v-col>
                  </v-row>
                </v-form>

              </v-container>

              <v-card-actions class="grey lighten-3">
                <v-btn text @click="step=2">Back</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="submitContest" :disabled="!stepComplete(3)" :loading="loading">
                  Submit
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-stepper-content>


        </v-stepper-items>
      </v-stepper>

    </div>
  </v-card>

</v-dialog>
</template>
<script>
/*
Notes:
What is required
Form validation

*/
import imagePicker from "@/components/app/image-picker-2";
import {
  mask
} from 'vue-the-mask'

export default {
  name: "",
  directives: {
    mask,
  },
  data: () => ({
    show_contest_dialog: false,
    step: 1,
    error: '',
    loading: false,
    contact_info: {
      name: '',
      email: '',
      phone: ''
    },
    contest: {
      brand_name: '',
      talk_about: '',
      prize: '',
      notes: '',
      brand_logo: null,
      prize_image: null
    }
  }),
  created() {
    this.$eventBus.$on('create_contest', function() {
      this.show_contest_dialog = true;
      this.step = 1
    }.bind(this))
  },
  computed: {
    rules() {
      return this.$helpers.rules
    },
    isFullScreen() {
      if (this.$store.state.app.display === 'xs' || this.$store.state.app.display === 'sm') {
        return false
      } else {
        return false
      }
    },
    canContinue() {
      return false;
    }
  },
  methods: {
    resetForm() {

      this.$refs['contact-form'].reset()
      this.$refs['contest-form'].reset()
      this.contest = {
        brand_name: '',
        talk_about: '',
        prize: '',
        notes: '',
        brand_logo: null,
        prize_image: null
      }
    },
    goNext() {
      this.step = 2
    },
    videoTutorial() {

        this.$eventBus.$emit('play_video', this.$store.state.app.tutorials.contest_create['Details'])


    },
    async submitContest() {
      if (!this.$refs['contact-form'].validate()) {
        alert("Contact info invalid")
        return
      }


      this.loading = true;
      try {
        try {
          await this.$api({
            method: "POST",
            url: `/account/business/contests`,
            data: {
              contest: this.contest,
              contact_info: this.contact_info
            }
          })
          this.show_contest_dialog = false;
          this.resetForm()
          this.$router.push("/business/profile")
          this.$eventBus.$emit('created_contest')
        } catch (ex2) {
          this.error = ex2.error
        }
        this.loading = false;

      } catch (ex) {
        alert(ex.error)
      }
      this.loading = false
    },
    stepComplete(step) {
      if (step == 1) {
        if (this.contest.brand_name && this.contest.talk_about && this.contest.prize && this.contest.notes) {
          return true
        }
      }
      if (step == 2) {
        if (this.contest.brand_logo && this.contest.prize_image) {
          return true
        }
      }
      if (step === 3) {
        if (this.error) {
          return false
        }
        if (this.contact_info.name && this.contact_info.phone && this.contact_info.email) {
          return true
        }
        return false
      }
      return false
    }
  },
  components: {
    imagePicker
  }
}
</script>
<style lang="scss" scoped>

</style>
